import TrashieMembershipContainer from './TrashieMembershipContainer';

export default TrashieMembershipContainer;
